import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteInitiativeTaskLinkRequest = {
	initiativeId: number;
	initiativeScopeId: number;
	initiativeTaskId: number;
	sonarObjectId: number;
};

export const deleteInitiativeTaskLink = createDeleteEndpoint<DeleteInitiativeTaskLinkRequest>(
	({ initiativeId, initiativeTaskId }) => `/api/v3/initiatives/${initiativeId}/tasks/${initiativeTaskId}/link`,
	{
		requestTransform: ({ initiativeScopeId }) => ({ initiativeScopeId })
	}
);
